import { useApi } from '@backstage/core-plugin-api';
import { uptimeMonitorApiRef } from '../api/UptimeMonitorApi';
import { useAsyncFn } from 'react-use';
import { useEffect } from 'react';
import { IssueDetailRequest, Issue, IssueEventDetails } from '../types';

export interface IssueDetailData {
  issue: Issue;
  eventDetails: IssueEventDetails;
}

export const useIssueDetail = (params: IssueDetailRequest | null) => {
  const api = useApi(uptimeMonitorApiRef);

  const [state, fetch] = useAsyncFn(async (): Promise<IssueDetailData | undefined> => {
    if (!params) return undefined;
    
    try {
      console.log('Fetching issue detail for:', params);
      
      const [issueResult, eventDetailsResult] = await Promise.all([
        api.getIssueDetail(params),
        api.getIssueEventLatest({ host: params.host, id: params.id })
      ]);
      
      console.log('Issue detail result:', issueResult);
      console.log('Event details result:', eventDetailsResult);
      
      return {
        issue: issueResult,
        eventDetails: eventDetailsResult
      };
    } catch (err: any) {
      console.error('Error fetching issue detail:', err);
      throw err;
    }
  }, [params?.host, params?.id]);

  // Add useEffect to automatically fetch when params change
  useEffect(() => {
    if (params) {
      fetch();
    }
  }, [params?.host, params?.id, fetch]);

  return {
    isLoading: state.loading,
    data: state.value,
    error: state.error,
    refetch: fetch,
  };
};